<template>
  <div class="container">
    <div class="radios" v-if="animation === 'slide'">
      <div class="radios__title">
        动画速度
      </div>
      <ul class="radios__list">
        <li
          class="radios__item"
          v-for="(item, key) in easingList"
          :class="{active: item.active}"
          :key="key"
          @click="setEasing(item)"
        >
          <i></i>
          <span>{{item.text}}</span>
        </li>
      </ul>
    </div>
    <div class="list">
      <div class="list__title">
        动画方向
      </div>
      <ul class="list__items">
        <li
          class="list__item"
          :class="{active: item.active}"
          v-for="(item, index) in showingList"
          :key="index"
          @click="selectEffect({ item, index, inOut: inOut })"
        >
          <div class="list__figure" :class="{[`icon-wrapper-${item.icon || item.to}`]: true}">
            <i class="icon" :class="{[`icon-effect-${item.icon || item.to}`]: true, 'is-out': inOut === 'out'}"></i>
          </div>
          <div class="list__caption">{{item.text}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      showingList: [],
      inOut: 'in',
      slideList: {
        out: [
          {text: '左移出', long: '向左移出', type: 'LeftOut', to: 'left', direction: '', active: false},
          {text: '右移出', long: '向右移出', type: 'RightOut', to: 'right', direction: '', active: false},
          {text: '上移出', long: '向上移出', type: 'UpOut', to: 'up', direction: '', active: false},
          {text: '下移出', long: '向下移出', type: 'DownOut', to: 'down', direction: '', active: false},
        ],
        in: [
          {text: '左移入', long: '从左移入', type: 'LeftIn', to: 'right', direction: '', active: false},
          {text: '右移入', long: '从右移入', type: 'RightIn', to: 'left', direction: '', active: false},
          {text: '上移入', long: '从上移入', type: 'UpIn', to: 'down', direction: '', active: false},
          {text: '下移入', long: '从下移入', type: 'DownIn', to: 'up', direction: '', active: false},
        ],
      },
      smearList: {
        out: [
          {text: '左擦除', long: '向左擦除', type: 'Smear', to: 'left', direction: 'w', active: false, icon: 'smear-w'},
          {text: '右擦除', long: '向右擦除', type: 'Smear', to: 'right', direction: 'e', active: false, icon: 'smear-e'},
          {text: '上擦除', long: '向上擦除', type: 'Smear', to: 'up', direction: 'n', active: false, icon: 'smear-n'},
          {text: '下擦除', long: '向下擦除', type: 'Smear', to: 'down', direction: 's', active: false, icon: 'smear-s'},
        ],
        in: [
          {text: '左擦入', long: '从左擦入', type: 'Smear', to: 'right', direction: 'e', active: false, icon: 'smear-e'},
          {text: '右擦入', long: '从右擦入', type: 'Smear', to: 'left', direction: 'w', active: false, icon: 'smear-w'},
          {text: '上擦入', long: '从上擦入', type: 'Smear', to: 'down', direction: 's', active: false, icon: 'smear-s'},
          {text: '下擦入', long: '从下擦入', type: 'Smear', to: 'up', direction: 'n', active: false, icon: 'smear-n'},
        ]
      },
      easingList: [
        {type: 'easeIn', text: '加速', active: false, num: 1, alias: 'easeOutExpo'},
        {type: 'easeOut', text: '减速', active: false, num: 2, alias: 'easeOutQuint'},
        {type: 'linear', text: '匀速', active: false, num: 0, alias: 'linear'}
      ],
      animation: '',
      reports: {
        'LeftOut': 'animation_setting_panel,click_ee_ffect_LeftOut,动画设置_出入场动画_左移出',
        'RightOut': 'animation_setting_panel,click_ee_ffect_RightOut,动画设置_出入场动画_右移出',
        'UpOut': 'animation_setting_panel,click_ee_ffect_UpOut,动画设置_出入场动画_上移出',
        'DownOut': 'animation_setting_panel,click_ee_ffect_DownOut,动画设置_出入场动画_下移出',
        'LeftIn': 'animation_setting_panel,click_ee_ffect_LeftIn,动画设置_出入场动画_左移入',
        'RightIn': 'animation_setting_panel,click_ee_ffect_RightIn,动画设置_出入场动画_右移入',
        'UpIn': 'animation_setting_panel,click_ee_ffect_UpIn,动画设置_出入场动画_上移入',
        'DownIn': 'animation_setting_panel,click_ee_ffect_DownIn,动画设置_出入场动画_下移入',

        'smear-w-out': 'animation_setting_panel,click_ee_ffect_smear-w-out,动画设置_出入场动画_左擦除',
        'smear-e-out': 'animation_setting_panel,click_ee_ffect_smear-e-out,动画设置_出入场动画_右擦除',
        'smear-n-out': 'animation_setting_panel,click_ee_ffect_smear-n-out,动画设置_出入场动画_上擦除',
        'smear-s-out': 'animation_setting_panel,click_ee_ffect_smear-s-out,动画设置_出入场动画_下擦除',

        'smear-w': 'animation_setting_panel,click_ee_ffect_smear-w,动画设置_出入场动画_左擦入',
        'smear-e': 'animation_setting_panel,click_ee_ffect_smear-e,动画设置_出入场动画_右擦入',
        'smear-n': 'animation_setting_panel,click_ee_ffect_smear-n,动画设置_出入场动画_上擦入',
        'smear-s': 'animation_setting_panel,click_ee_ffect_smear-s,动画设置_出入场动画_下擦入',
      }
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
      'SelectSprites_Msg',
      'SpriteBeforeSwap'
    ]),
    oneSpriteEasing () {
      if (this.SelectSprites_Msg && this.SelectSprites_Msg.length === 1) {
        return this.inOut === 'out'
          ? this.SelectSprites_Msg[0].effect.exitAnim.easing
          : this.SelectSprites_Msg[0].effect.easing
      }
      return false
    },
    oneSprite () {
      if (this.SelectSprites_Msg && this.SelectSprites_Msg.length === 1) {
        return this.SelectSprites_Msg[0]
      }
      return false
    }
  },
  watch: {
    'boxData.judgeBox': {
      handler (val) {
        if (val) {

          this.showList();
        }
      }
    }
  },
  created () {
    this.$bus.on('undoRedoHandle', ({type, mod} = {}) => {
      this.showList({
        inOut: this.inOut
      });
    });
  },
  methods: {
    showList ({
      inOut,
      animation
    } = {}) {
      animation = animation || this.animation;
      if (!animation) {
        return;
      }
      this.showingList = this[animation + 'List'][inOut];
      this.inOut = inOut;
      this.animation = animation;

      this.updateItmes();
    },

    selectEffect ({
      item,
      index,
      inOut
    }= {}) {
      let reportName = '';
      if (item.icon) {
        reportName = inOut === 'out' ? item.icon + '-out' : item.icon;
      } else {
        reportName = item.type;
      }
      this.$analysis(this.reports[reportName]);
      this.updateEffect({
        item,
        index,
        inOut
      });

      this.updateItmes();
      this.$bus.emit('childEffects.optionChanged');
    },

    updateEffect ({
      item,
      index,
      inOut
    } = {}) {
      this.SelectSprites_Msg.forEach((sprite) => {
        let code = item.type;
        let inOutType;

        if (inOut === 'in') {
          let {start, end} = sprite.effect.entranceAnim;
          if (code === 'None') {
            start = end;
          } else {
            start = Math.max(end - 500, 0);
          }

          sprite.updateEffect({
            code,
            direction: item.direction,
            entranceAnim: {
              start,
              end,
              hand: null
            }
          }, true);
          inOutType = 'entrance';
        }
        if (inOut === 'out') {
          let {start, end} = sprite.effect.exitAnim;
          if (code === 'None') {
            end = start;
          } else {
            if(start >= this.TOOL.selectedScenes.duration) {
              start = this.TOOL.selectedScenes.duration - 500;
            }
            end = Math.min(start + 500, this.TOOL.selectedScenes.duration);
          }

          sprite.updateEffect({
            direction: sprite.effect.direction,
            exitAnim: {
              type: code,
              direction: item.direction,
              start,
              end
            }
          }, true);
          inOutType = 'exit';
        }
        sprite.effect.init();
        this.$bus.emit('updateEffect_vue', {
          sprite: sprite,
          effect: sprite.effect || {},
          type: inOutType
        });
      });
    },

    updateItmes (sprite) {
      let isEffectsSame = true;
      if (this.SelectSprites_Msg.length > 1 && this.inOut === 'in') {
        isEffectsSame = this.SelectSprites_Msg.every((s) => {
          return s.effect.code === this.SelectSprites_Msg[0].effect.code
        })
      }
      if (this.SelectSprites_Msg.length > 1 && this.inOut === 'out') {
        isEffectsSame = this.SelectSprites_Msg.every((s) => {
          return s.effect.exitAnim.type
            === this.SelectSprites_Msg[0].effect.exitAnim.type
        })
      }
      if (!isEffectsSame) {
        this.showingList.forEach((item) => {
          item.active = false;
        });
        return;
      }

      if (!sprite) {
        sprite = this.SelectSprites_Msg.length
          ? this.SelectSprites_Msg[0]
          : {};
      }

      let effect = sprite.effect;
      let inEff = effect.type || effect.code || 'None';
      let outEff = effect.exitAnim.type;
      let eff = this.inOut === 'in' ? inEff : outEff;

      if (this.animation === 'slide') {
        let inEasing = effect.easing;
        let outEasing = effect.exitAnim.easing;
        if (outEasing == null) {
          sprite.updateEffect({
            exitAnim: {
              easing: 'easeOutExpo'
            }
          });
          outEasing = effect.exitAnim.easing;
        }
        let easing = this.inOut === 'in' ? inEasing : outEasing;
        this.easingList.forEach((item) => {
          if (item.alias === easing || item.num === easing) {
            item.active = true;
            this.$set(item, 'active', true);
          } else {
            item.active = false;
            this.$set(item, 'active', false);
          }
        })
      }

      if (this.animation === 'smear') {
        let inDire = effect.direction;
        let outDire = effect.exitAnim.direction;
        let dire = this.inOut === 'in' ? inDire : outDire;
        this.showingList.forEach((item) => {
          if (item.direction === dire) {
            item.active = true;
          } else {
            item.active = false;
          }
        })
        return;
      }
      this.showingList.forEach((item) => {
        if (item.type === eff) {
          item.active = true;
        } else {
          item.active = false;
        }
      })
    },

    setEasing (item) {
      this.SelectSprites_Msg.forEach((s) => {
        this.setEasing_(item, s)
      });

      this.$bus.emit('childEffects.optionChanged');
    },

    setEasing_ (item, sprite) {
      // if (!this.oneSprite) {
      //   return;
      // }
      // let sprite = this.oneSprite;
      let inOutType;
      let effect = sprite.effect;
      if (this.inOut === 'out') {
        sprite.updateEffect({
          exitAnim: {
            type: /LeftOut|RightOut|UpOut|DownOut/.test(effect.exitAnim.type)
              ? effect.exitAnim.type
              : 'LeftOut',
            easing: item.alias
          }
        }, true);
        inOutType = 'exit';
      } else {
        sprite.updateEffect({
          code: /LeftIn|RightIn|UpIn|DownIn/.test(effect.code)
            ? effect.code
            : 'LeftIn',
          easing: item.alias
        }, true);
        inOutType = 'entrance';
      }
      sprite.effect.init();
      this.$bus.emit('updateEffect_vue', {
        sprite: sprite,
        effect: sprite.effect || {},
        type: inOutType
      });

      this.$bus.emit('effectOptions.selectEffect');
      this.updateItmes();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/_colors.scss";

.radios {
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 15px;
  margin-bottom: 13px;

  &__title {
    margin-bottom: 13px;
    font-size: 14px;
    text-align-last: left;
  }

  &__list {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__item {
    display: flex;
    align-items: center;
    font-size: 14px;
    cursor: pointer;

    &>i {
      width: 16px;
      height: 16px;
      border-radius: 16px;
      border: solid 1px #9692a9;
    }
    &>span {
      padding-left: 5px;
    }

    &.active>i {
      background-color: #9692a9;
      box-shadow: 0 0 0 2px #ffffff inset;
    }
  }
}

.list {
  margin-top: 22px;
  padding-left: 20px;
  padding-right: 20px;

  &__title {
    margin-bottom: 13px;
    font-size: 14px;
    text-align-last: left;
  }

  & > ul {
    display: flex;
    // flex-wrap: wrap;
  }
  &__items {
    width: 226px;
    justify-content: space-between;
    margin-left: -4px;
  }
  &__item {
    margin-right: 6px;
    margin-bottom: 15px;
    cursor: pointer;

    &:nth-child(4n) {
      margin-right: 0;
    }

    &.active .list__figure {
      box-shadow: 0 0 0 2px $c2;
    }
  }
  &__figure {
    width: 50px;
    height: 50px;
    background-color: #f0f0f8;
    border-radius: 4px;
    overflow: hidden;
  }
  &__caption {
    margin-top: 7px;
  }
}

.list .list__item .list__figure >.icon {
  width: 50px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/effectSetting/childEffects.vue